import { render, staticRenderFns } from "./block.vue?vue&type=template&id=4bdc351b&scoped=true&"
import script from "./block.vue?vue&type=script&lang=ts&"
export * from "./block.vue?vue&type=script&lang=ts&"
import style0 from "./block.vue?vue&type=style&index=0&id=4bdc351b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc351b",
  null
  
)

export default component.exports